import { InjectionToken } from '@angular/core';

export interface CommonEnvironment {
  auth: {
    clientId: string;
    loginUrl: string;
    logoutUrl: string;
    tokenUrl: string;
  };
  roles: {
    shmAdGroups: string[];
    gcomAdGroups: string[];
  };
}

export const COMMON_ENVIRONMENT = new InjectionToken<CommonEnvironment>(
  'common.environment'
);
